/**
 * @generated SignedSource<<5ceb6f69ac9af5110c3548d0b7d98a59>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type processFields414BadPattern$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"processFields">;
  } | null | undefined;
  readonly " $fragmentType": "processFields414BadPattern";
};
export type processFields414BadPattern$key = {
  readonly " $data"?: processFields414BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"processFields414BadPattern">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "processFields414BadPattern"
};

(node as any).hash = "63dcae3c3ea3baff358f8be3ed98834f";

export default node;
